import { css } from '@emotion/react';
import { Section } from 'client/components/Layout/Settings';
import { ComponentEnvironment } from './ComponentEnvironment';
import { ComponentIcon } from './ComponentIcon';
import { ComponentParameterGroups } from './ComponentParameterGroups';
import { useComponent } from './componentUtils';

export const ComponentsSection = ({ stackComponentID }: { stackComponentID: number }) => {
  const component = useComponent(stackComponentID);

  if (!component || !component.config) return null;

  const { config } = component;

  return (
    <Section
      title={
        <>
          <ComponentIcon url={`${component.url}#${component.ref}`} type={component.config.type} /> {component.config.name}
        </>
      }
      subtitle={`Configuration for the ${config.name} ${config.type}.`}
      css={sectionStyle}
    >
      <ComponentParameterGroups stackComponentID={stackComponentID} />
      <ComponentEnvironment stackComponentID={stackComponentID} />
    </Section>
  );
};

const sectionStyle = css`
  header {
    &::before {
      content: none;
    }

    > h6 > figure {
      margin-bottom: 8px;
    }
  }

  > div {
    > section:last-child,
    > .accordion {
      margin-bottom: 0;
      border: none;
    }
  }
`;
